import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslatePipe]
})
export class ConfirmationDialogComponent {
    private router = inject(Router);

    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { message: string; subMessage: string; iconSrc?: string }
    ) {}

    closeDialog(): void {
        this.dialogRef.close();
    }

    confirm(): void {
        this.dialogRef.close('yes');
    }
}
